import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormControl, FormLabel, IconButton, Stack, TextareaAutosize, Tooltip } from '@mui/material';
import { DisplaySettings } from '@mui/icons-material';
import PacoteComp from '../../common/PacoteComp';
import Service from '../../../util/Service';
import RulesPopover from '../portal/user/RulesPopover';

export default function EditarDescricaoPaginaDialog(props) {
    const { pagina, setPagina, placement, close } = props;
    const [open, setOpen] = React.useState(false);
    const [pacote, setPacote] = React.useState();
    const [nome, setNome] = React.useState('');
    const [titulo, setTitulo] = React.useState('');
    const [descricao, setDescricao] = React.useState('');
    const [index, setIndex] = React.useState(0);
    const [estilo, setEstilo] = React.useState('');
    const [regra, setRegra] = React.useState('');

    React.useEffect(() => {
        if (open) {
            const r = pagina;
            setNome(r.nome);
            setPacote(r.pacote);
            setTitulo(r.titulo);
            setDescricao(r.descricao);
            setEstilo(r.estilo);
            setRegra(r.regra);
            if (r.index) setIndex(r.index);
            else setIndex(0);
        }
    }, [open])

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        close();
    };

    function handleSalva() {
        let dado = { ...pagina }
        dado.nome = nome;
        dado.titulo = titulo;
        dado.descricao = descricao;
        dado.index = index;
        dado.estilo = estilo;
        dado.regra = regra;
        dado.pacote = pacote;

        console.log(dado);
        Service.POST("/api/security/paginaHtml", dado).then(r => {
            setPagina(r);
            handleClose();
        }).catch(e => {
            alert(e);
        })
    }
    function handleUpdatePacote(pk) {
        console.log(pk);
        const dado = {
            id: pagina.id,
            pacote: pk
        }
        Service.POST("/api/security/paginaHtml/salvaPacote", dado).then(ret => {
            console.log(ret);
            var p = { ...pagina };
            p.pacote = pk
            setPagina(p);
        });
    }
    function handleAddRule(rule) {
        console.log('>>>handleAddRule<<<')
        setRegra(rule.nome)
    }

    return (
        <React.Fragment>
            <Tooltip title="Abrir Descrição" placement={placement}>
                <IconButton aria-label="edit"
                    onClick={() => {                        
                        handleClickOpen();
                    }}
                >
                    <DisplaySettings />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{pagina.nome}</DialogTitle>
                <DialogContent>

                    <Stack spacing={2} sx={{ mt: 2 }}>
                        <Stack direction="row" spacing={2}>
                            <PacoteComp
                                position="fixo"
                                // classeName={nome}
                                pack={pacote}
                                action={handleUpdatePacote}
                                variant="outlined"
                                label="Pacote"
                                style={{
                                    width: '500px'
                                }}
                            />
                            <TextField autoFocus
                                label="Nome" variant="outlined" value={nome}
                                // fullWidth 
                                size="small"
                                onChange={(e) => {
                                    setNome(e.target.value);
                                }}
                            />
                        </Stack>

                        <TextField label="Titulo" variant="outlined" value={titulo}
                            // fullWidth 
                            size="small"
                            onChange={(e) => {
                                setTitulo(e.target.value);
                            }}
                        />
                        <Stack direction="row" spacing={2}>
                            <TextField size="small"
                                label="index"
                                variant="outlined"
                                // fullWidth
                                value={index}
                                onChange={(e) => setIndex(e.target.value.replace(/\D/g, ""))}
                            />
                            <RulesPopover action={handleAddRule} showTxt={true} regra={regra} />
                        </Stack>
                        <FormControl>
                            <FormLabel >Descrição</FormLabel>
                            <TextareaAutosize
                                aria-label="minimum height"
                                minRows={3}
                                placeholder="Descrição minima da pagina"
                                style={{ width: '100%' }}
                                value={descricao ? descricao : ''}
                                onChange={(e) => {
                                    setDescricao(e.target.value);
                                }}
                            />
                            <TextField sx={{ mt: 2 }}
                                label="Estilo em linha da pagina"
                                variant="outlined"
                                fullWidth size="small"
                                value={estilo}
                                onChange={(e) => setEstilo(e.target.value)}
                            />
                        </FormControl>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button onClick={handleSalva}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
